import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentPipe, ApContentComponent } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';

import { ErrorComponent } from './error.component';

/**
 * @ngdoc module
 * @name ErrorModule
 */
@NgModule({
    declarations: [ErrorComponent],
    imports: [ApIllustrationComponent, ApButtonComponent, ApContentPipe, ApContentComponent, CommonModule],
    exports: [ErrorComponent]
})
export class ErrorModule {}
